export namespace ContactSupport {
  export interface ContactSupportBase {
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    companySeekingGrantFrom: string;
    applicationId?: number;
    program: string;
    organization: string;
    ein: string;
    questionDescription: string;
  }
  export interface ContactSupportModalReturn extends ContactSupportBase {
    reason: ContactReasonFullList;
  }

  export interface ContactSupportForApi extends ContactSupportBase {
    reason: string;
  }

  export enum ContactReasonFullList {
    CHANGE_PASSWORD = 0,
    UPDATE_EMAIL = 1,
    OTHER = 2,
    PROFILE_INFO = 3,
    FORMS = 4,
    DATA_MISSING = 5,
    APPLICATION_NOMINATION = 6,
    UNABLE_TO_FIND_ORG = 7
  }
}
